import React, { useState, useEffect } from "react";
import api from '../../../../../../../api';
import {
    Form,
    Input,
    TextArea,
    Message,
    Icon,
    Table
} from "semantic-ui-react";
import Modal from '../../../../../ChatSetup/components/Modal';
import "./DataConnectPage.css";

const InboundMcpToolModal = ({ open, onClose, preformData, setshowErrortype, workspace_id, loadMcpTools }) => {
    const [formData, setFormData] = useState(preformData);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showError, setshowError] = useState({ type: "", message: "" });
    const [validationErrors, setValidationErrors] = useState({});

    const protocolOptions = [
        { key: 'shttp', text: 'SHTTP', value: 'shttp' },
        // { key: 'stdio', text: 'STDIO', value: 'stdio' },
        // { key: 'sse', text: 'SSE (Deprecated)', value: 'sse' },
    ];

    useEffect(() => {
        setFormData(preformData);
        setValidationErrors({});
    }, [preformData]);

    const handleInputChange = (e, { name, value }) => {
        setFormData({ ...formData, [name]: value });
        if (validationErrors[name]) {
            setValidationErrors({ ...validationErrors, [name]: "" });
        }
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.name) {
            errors.name = "Tool name is required";
        } else if (!/^[a-zA-Z0-9_-]{1,64}$/.test(formData.name)) {
            errors.name = "Tool name must contain only letters, numbers, underscores (_), and hyphens (-), and be 1-64 characters long";
        }

        if (!formData.server_url) {
            errors.server_url = "Server URL is required";
        } else {
            try {
                new URL(formData.server_url);
            } catch (e) {
                errors.server_url = "Invalid Server URL format";
            }
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const addHeader = () => {
        const newHeaders = [...(formData.headers || []), { key: "", value: "" }];
        setFormData({ ...formData, headers: newHeaders });
    };

    const removeHeader = (index) => {
        const newHeaders = formData.headers.filter((_, i) => i !== index);
        setFormData({ ...formData, headers: newHeaders });
    };

    const handleHeaderChange = (index, field, value) => {
        const newHeaders = [...formData.headers];
        newHeaders[index][field] = value;
        setFormData({ ...formData, headers: newHeaders });
    };

    const handleSubmit = () => {
        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
        setshowError({ type: "", message: "" });

        const payload = {
            workspace_id: atob(workspace_id),
            name: formData.name,
            description: formData.description || "",
            server_url: formData.server_url,
            protocol: formData.protocol || "shttp",
            headers: formData.headers && formData.headers.length > 0
                ? formData.headers.filter(h => h.key && h.value)
                : []
        };

        if (formData.id) {
            payload.id = formData.id;
            api.InboundMcpTooling.editMcpTool(payload).then((res) => {
                if (res && res.success) {
                    setshowErrortype({ type: "positive", title: "Success!", message: "Inbound MCP tool updated successfully." });
                    loadMcpTools();
                    onClose();
                } else {
                    setshowError({ type: "negative", message: res.error || "Failed to update tool" });
                }
                setIsSubmitting(false);
            }).catch(() => {
                setshowError({ type: "negative", message: "Failed to update tool" });
                setIsSubmitting(false);
            });
        } else {
            api.InboundMcpTooling.saveMcpTool(payload).then((res) => {
                if (res && res.success) {
                    setshowErrortype({ type: "positive", title: "Success!", message: "Inbound MCP tool created successfully." });
                    loadMcpTools();
                    onClose();
                } else {
                    setshowError({ type: "negative", message: res.error || "Failed to create tool" });
                }
                setIsSubmitting(false);
            }).catch(() => {
                setshowError({ type: "negative", message: "Failed to create tool" });
                setIsSubmitting(false);
            });
        }
    };

    const modalBody = (
        <>
            {showError.message && (
                <Message negative={showError.type === "negative"} positive={showError.type === "positive"}>
                    {showError.message}
                </Message>
            )}

            <Form>
                <Form.Field required error={!!validationErrors.name}>
                    <label>Tool Name</label>
                    <Input
                        name="name"
                        placeholder="Enter tool name (only letters, numbers, _, -)"
                        value={formData.name}
                        onChange={handleInputChange}
                        error={!!validationErrors.name}
                    />
                    {validationErrors.name && (
                        <span style={{ color: '#9f3a38', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                            {validationErrors.name}
                        </span>
                    )}
                </Form.Field>

                <Form.Field>
                    <label>Description</label>
                    <TextArea
                        name="description"
                        placeholder="Tool description (optional)"
                        value={formData.description}
                        onChange={handleInputChange}
                        rows={2}
                    />
                </Form.Field>

                <Form.Field required error={!!validationErrors.server_url}>
                    <label>MCP Server URL</label>
                    <Input
                        name="server_url"
                        placeholder="https://your-mcp-server.com"
                        value={formData.server_url}
                        onChange={handleInputChange}
                        error={!!validationErrors.server_url}
                    />
                    {validationErrors.server_url && (
                        <span style={{ color: '#9f3a38', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                            {validationErrors.server_url}
                        </span>
                    )}
                </Form.Field>

                <Form.Field>
                    <label>Protocol</label>
                    <select
                        name="protocol"
                        className="form-control"
                        value={formData.protocol || "shttp"}
                        onChange={(e) => handleInputChange(e, { name: 'protocol', value: e.target.value })}
                    >
                        {protocolOptions.map(option => (
                            <option key={option.key} value={option.value}>
                                {option.text}
                            </option>
                        ))}
                    </select>
                </Form.Field>

                <Form.Field>
                    <label>
                        Headers (Optional)
                        <button
                            type="button"
                            className="btn linear-gradient yr-add-new onclick"
                            onClick={addHeader}
                            style={{ marginLeft: "10px", boxShadow: 'none' }}
                        >
                            <i className="fa fa-plus"></i> Add Header
                        </button>
                    </label>
                    {formData.headers && formData.headers.length > 0 && (
                        <Table celled compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={6}>Header Key</Table.HeaderCell>
                                    <Table.HeaderCell width={8}>Header Value</Table.HeaderCell>
                                    <Table.HeaderCell width={2}>Action</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {formData.headers.map((header, index) => (
                                    <Table.Row key={index}>
                                        <Table.Cell>
                                            <Input
                                                fluid
                                                placeholder="e.g. Authorization"
                                                value={header.key}
                                                onChange={(e) => handleHeaderChange(index, 'key', e.target.value)}
                                            />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Input
                                                fluid
                                                type="password"
                                                placeholder="Header value (masked)"
                                                value={header.value}
                                                onChange={(e) => handleHeaderChange(index, 'value', e.target.value)}
                                            />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <button
                                                type="button"
                                                className="btn btn-icon"
                                                onClick={() => removeHeader(index)}
                                            >
                                                <Icon name="trash" color="red" />
                                            </button>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    )}
                    {formData.id && (
                        <p style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
                            <Icon name="info circle" />
                            For security, existing header values are not shown. Re-enter only if you want to update them.
                        </p>
                    )}
                </Form.Field>
            </Form>
        </>
    );

    const modalFooter = (
        <div className="modal-footer">
            <button
                type="button"
                className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
                onClick={onClose}
                disabled={isSubmitting}
            >
                <span>Cancel</span>
            </button>
            <button
                type="button"
                className="btn linear-gradient yr-submitbtn btn-sm"
                onClick={handleSubmit}
                disabled={isSubmitting}
            >
                <span>{isSubmitting ? "Saving..." : (formData.id ? "Update" : "Create")}</span>
            </button>
        </div>
    );

    return (
        <Modal
            show={open}
            onclose={onClose}
            title={formData.id ? "Edit Inbound MCP Tool" : "Add Inbound MCP Tool"}
            maxWidth={700}
            body={modalBody}
            footer={modalFooter}
            loading={isSubmitting}
        />
    );
};

export default InboundMcpToolModal;
